var _style, _g, _g2, _g3, _g4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvanceThemeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:none;opacity:0.5;}\r\n\t.st2{fill:#0072C6;}\r\n\t.st3{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Editabl"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000137840826117259389740000012121897452955012793_",
    className: "st1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 7.5,
    className: "st2",
    width: 7.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 9.7,
    className: "st2",
    width: 4.3,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7,16.5v1h3.4v-1H9v-1h1.4v-1l-6.8,0l0-10.8l12.8,0v5.1h1V3.7c0-0.6-0.5-1-1-1H3.6c-0.6,0-1,0.5-1,1v10.8 c0,0.6,0.5,1,1,1H8v1L7,16.5L7,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000027573515013340329520000000006850674116269972_",
    className: "st2",
    d: "M18.2,11.6c-0.2,0.2-0.4,0.4-0.6,0.6 c0,0,0,0.1,0,0.1c0.1,0.2,0.2,0.4,0.2,0.6c0,0,0,0.1,0.1,0.1c0.3,0,0.6,0,0.8,0c0,0,0.1,0,0.1,0c0,0.5,0,1,0,1.5c0,0-0.1,0-0.1,0 c-0.3,0-0.6,0-0.8,0c0,0-0.1,0-0.1,0.1c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0.1,0,0.1c0.2,0.2,0.4,0.4,0.6,0.6c0,0,0,0,0.1,0 c-0.4,0.4-0.7,0.7-1.1,1.1c0,0,0,0,0,0c-0.2-0.2-0.4-0.4-0.6-0.6c0,0-0.1,0-0.1,0c-0.2,0.1-0.4,0.2-0.6,0.2c0,0-0.1,0-0.1,0.1 c0,0.3,0,0.6,0,0.9c-0.5,0-1,0-1.5,0c0,0,0,0,0-0.1c0-0.3,0-0.5,0-0.8c0-0.1,0-0.1-0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2 c0,0-0.1,0-0.1,0c-0.2,0.2-0.4,0.4-0.6,0.6c-0.4-0.4-0.7-0.7-1.1-1.1c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.4-0.4,0.6-0.5c0,0,0,0,0-0.1 c-0.1-0.2-0.2-0.4-0.2-0.6c0,0,0-0.1-0.1-0.1c-0.3,0-0.6,0-0.8,0c0,0-0.1,0-0.1,0c0-0.5,0-1,0-1.5c0,0,0,0,0.1,0c0.3,0,0.6,0,0.9,0 c0,0,0.1,0,0.1-0.1c0.1-0.2,0.2-0.4,0.2-0.6c0,0,0-0.1,0-0.1c-0.2-0.2-0.4-0.4-0.6-0.6c0,0,0,0,0,0c0.4-0.4,0.7-0.7,1.1-1.1 c0,0,0,0,0,0c0.2,0.2,0.4,0.4,0.6,0.6c0,0,0,0,0.1,0c0.2-0.1,0.4-0.2,0.6-0.2c0,0,0.1,0,0.1-0.1c0-0.3,0-0.6,0-0.8c0,0,0-0.1,0-0.1 c0.5,0,1,0,1.5,0c0,0,0,0.1,0,0.1c0,0.3,0,0.6,0,0.8c0,0,0,0.1,0.1,0.1c0.2,0.1,0.4,0.2,0.6,0.2c0,0,0.1,0,0.1,0 c0.2-0.2,0.4-0.4,0.6-0.6c0,0,0,0,0.1,0C17.5,10.9,17.9,11.2,18.2,11.6z M15,12.2c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5 c0.8,0,1.5-0.7,1.5-1.5C16.5,12.9,15.8,12.2,15,12.2z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceThemeSelected);
export default __webpack_public_path__ + "static/media/AdvanceThemeSelected.350e364a7a0a13d6a01772714cc4628f.svg";
export { ForwardRef as ReactComponent };